<template>
  <div class="bunkazai">
    <div class="two_column background" v-if="this.$route.params.lang === 'ja'">
      <div class="mainarea fix">
        <img class="right" src='image/top/img_main01.jpg'>
        <div class="left textarea">
          <h3>和船文化</h3>
          <p>江戸時代、物流の主役は船であった。尾張の国の人が所有する荷物運搬用の大型船を尾州廻船といい、このうち内海やその周辺を拠点としたものは内海船と呼ばれた。全盛期には100艘もの船を抱えた巨大集団で、瀬戸内海から江戸にかけて広く活躍した。</p>
          <p><a href="https://minamichita-museum.com/wasen/index.html">詳しく見る</a></p>
        </div>
      </div>
    </div>
    <div class="two_column background" v-if="this.$route.params.lang === 'en'">
      <div class="mainarea fix">
        <img class="right" src='image/top/img_main01.jpg'>
        <div class="left textarea">
          <h3>Japanese-style ship culture</h3>
          <p>From the second half of the Edo period through the Meiji period, trading ships from the southern part of the Chita Peninsula(Utsumi, Minamichita in particular)were called "Utsumi-bune". Utsumi-bune operated between Edo (Tokyo) and the Seto Inland Sea. Their main cargo was rice, and they also carried soybeans as well as salt, tatami mats, and fish to be used as an ingredient in fertilizer.<br>The ships would purchase these goods in the areas where they were produced, and then earn a profit by exploiting the price difference in the places where they were consumed.</p>
          <p><a href="https://minamichita-museum.com/wasen/en/index.html">See more</a></p>
        </div>
      </div>
    </div>
    <div class="two_column" v-if="this.$route.params.lang === 'ja'">
      <div class="mainarea fix">
        <img class="left" src='image/top/img_main02.jpg'>
        <div class="right textarea">
          <h3>考古資料</h3>
          <p>南知多町には、百数十か所の数多くの遺跡が確認されている。縄文時代の遺跡は、今から約8400年前と推定され、県内最古の貝塚である先苅貝塚（内海）をはじめ、数多く存在する。これら縄文時代の遺跡は内海地区と片名地区に多く、篠島及び日間賀島でも中期以降の遺跡が確認されている。古墳は後期古墳ばかりであるが、日間賀島の35基を中心に豊浜地区、片名地区など各地区で確認されている。古墳時代から古代にかけての製塩遺跡は各地区の沿岸で認められ、この時期に塩づくりが町のほぼ全域で行われていたことがわかる。そのほか各時代の遺跡が町内各地で確認されており、本町域は、古くから人が生活してきた地域である。</p>
          <p><router-link :to="{name:'KoukoDashi', params:{category:'kouko', tab:'map'}}">詳しく見る</router-link></p>
        </div>
      </div>
    </div>
    <div class="two_column" v-if="this.$route.params.lang === 'en'">
      <div class="mainarea fix">
        <img class="left" src='image/top/img_main02.jpg'>
        <div class="right textarea">
          <h3>Archaeological Materials</h3>
          <p>Minamichita Town has many archaeological remains. The oldest of these is the Mazukari Shell Mound, which dates back about 8,400 years. Remains from various later periods have also been identified throughout the town. Remains from the Jomon period have been frequently discovered in the Utsumi, Oi and Katana districts, and also in Shinojima and Himakajima. Remains from the Kofun period in the form of ancient tombs have been discovered in the Toyohama, Katana, and Shinojima districts, as well as 35 tombs in Himakajima. Additionally, remains from salt-making activities spanning the Kofun to Heian periods have also been identified.</p>
          <p><router-link :to="{name:'KoukoDashi', params:{category:'kouko', tab:'map'}}">See more</router-link></p>
        </div>
      </div>
    </div>
    <div class="two_column background" v-if="this.$route.params.lang === 'ja'">
      <div class="mainarea fix">
        <img class="right" src='image/top/img_main03.jpg'>
        <div class="left textarea">
          <h3>南知多町の山車</h3>
          <p>南知多町では、４月第１日曜日に行われる「内海の春まつり」において、五穀豊穣、村内安全などを願い各地区で４台の山車が巡行する。７月第２土曜日に行われる「大井の夏まつり」では、年に一度、村社の豊受神社の神が港の中にある津島神社の神のもとへ渡る際の警護役として１台の山車が巡行する。秋は、「羽豆神社の大名行列」（１０月第２土、日曜日）では、岬にある羽豆神社の神が村内にある「御旅所」に渡る際の警護役として５台の山車が巡行する。山海の西村区の祭礼（１０月下旬から１１月上旬頃の日曜日）では山車１台が巡行する（３年程度に１回）。以上のように、本町で現在曳き廻されている山車は１１台で、内海４台、大井１台、師崎５台、山海１台である。このほか、曳き廻されてはいないが、内海内福寺区の山車（万延元年製作）１台と豊浜半月地区の船山車（明治７年製作）１台がある。また、豊浜の中村区で曳き廻されていた山車（江戸後期製作）の前山部分が立川美術館で展示されている。</p>
          <p><router-link :to="{name:'KoukoDashi', params:{category:'dashi', tab:'map'}}">詳しく見る</router-link></p>
        </div>
      </div>
    </div>
    <div class="two_column background" v-if="this.$route.params.lang === 'en'">
      <div class="mainarea fix">
        <img class="right" src='image/top/img_main03.jpg'>
        <div class="left textarea">
          <h3>Festival Floats</h3>
          <p>Currently, 11 festival floats are paraded around Minamichita Town. There are four from the Utsumi district, one from the Yamami district, one from the Oi district, and five from the Morozaki district. There are also one from the Utsumi district and one from the Toyohama district that are not paraded. The float from the Toyohama district is a boat-shaped float.</p>
          <p><router-link :to="{name:'KoukoDashi', params:{category:'dashi', tab:'map'}}">See more</router-link></p>
        </div>
      </div>
    </div>
    <div class="four_column" v-if="this.$route.params.lang === 'ja'">
      <ul class="sitearea fix">
        <li>
          <a href="https://www.town.minamichita.lg.jp/kankosangyou/bunkasports/1001438.html" target="_blank">
            <img src="image/top/banner_movie.png">
            <p>映像</p>
          </a>
        </li>
        <li>
          <a href="http://geoalpha.jp/minamichita/" target="_blank">
            <img src="image/top/banner_app.png">
            <p>文化遺産ナビ</p>
          </a>
        </li>
        <li>
          <a href="https://www.town.minamichita.lg.jp/kankosangyou/bunkasports/index.html" target="_blank">
            <img src="image/top/banner_event.png">
            <p>町の展示・イベント事業</p>
          </a>
        </li>
        <li>
          <a href="https://www.town.minamichita.lg.jp/kankosangyou/bunkasports/1001407/1001408.html" target="_blank">
            <img src="image/top/banner_pamphlet.png">
            <p>パンフレット</p>
          </a>
        </li>
      </ul>
    </div>
    <div class="four_column" v-if="this.$route.params.lang === 'en'">
      <ul class="sitearea fix">
        <li>
          <a href="https://www.town.minamichita.lg.jp/kankosangyou/bunkasports/1001438.html" target="_blank">
            <img src="image/top/banner_movie.png">
            <p>Video</p>
          </a>
        </li>
        <li>
          <a href="http://geoalpha.jp/minamichita/" target="_blank">
            <img src="image/top/banner_app.png">
            <p>Minamichita Cultural Heritage</p>
          </a>
        </li>
        <li>
          <a href="https://www.town.minamichita.lg.jp/kankosangyou/bunkasports/index.html" target="_blank">
            <img src="image/top/banner_event.png">
            <p>Display in the town/Events</p>
          </a>
        </li>
        <li>
          <a href="https://www.town.minamichita.lg.jp/kankosangyou/bunkasports/1001407/1001408.html" target="_blank">
            <img src="image/top/banner_pamphlet.png">
            <p>Brochure</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="less">
  //mediaquery設定
  @screen-xs-max: 660px; //スマホ
  @screen-sm-max: 768px; //ipad
  @screen-lg-max: 1200px; //ブラウザサイズ1200px以下
  @screen-hg-max: 1400px; //ブラウザサイズ1400px以下
  .screen-xs(@rules) {
      @media (max-width: @screen-xs-max) { @rules(); } 
  }
  .screen-sm(@rules) {
      @media (max-width: @screen-sm-max) { @rules(); }
  }
  .screen-lg(@rules) {
      @media (max-width: @screen-lg-max) { @rules(); }
  }
  .screen-hg(@rules) {
      @media (max-width: @screen-hg-max) { @rules(); }
  }

  @mb50 : 50px;

  .bunkazai{
    .screen-sm({
      margin-top: 55px;
    });
    .background{
      background-color: #E9EFF0;
    }
    .two_column{
      padding: 70px 0 80px;
      text-align: left;
      @media (max-width: 999px) {
        padding: 0 0 70px;
      }
      img{
        @media (max-width: 999px) {
          margin: 0 -6% 30px;
        }
      }
      .mainarea{
        margin: 0 auto;
        width: 1400px;
        .screen-hg({
          width: 90%;
        });
        .left{
          float: left;
          width: 50%;
          @media (max-width: 999px) {
            float: none;
            width: 112%;
          }
        }
        .right{
          float: right;
          width: 50%;
          @media (max-width: 999px) {
            float: none;
            width: 112%;
          }
        }
        .textarea{
          padding: 0 7.5%;
          width: 35%;
          @media (max-width: 999px) {
            padding: 0;
            width: 100%;
          }
          h3{
            margin-bottom: @mb50;
            color: #3F698F;
            font-size: 28px;
            font-weight: normal;
            @media (max-width: 999px) {
              text-align: center;
            }
            .screen-sm({
              margin-bottom: 30px;
            });
          }
          p{
            &:nth-of-type(1){
              margin-bottom: @mb50;
              font-size: 16px;
              line-height: 2;
              .screen-sm({
                margin-bottom: 30px;
                line-height: 2;
              });
              .screen-xs({
                font-size: 14px;
              });
            }
            &:nth-of-type(2){
              width: 200px;
              background-color: #3F698F;
              color: #fff;
              font-size: 18px;
              text-align: center;
              position: relative;
              @media (max-width: 999px) {
                margin: 0 auto;
              }
              .screen-xs({
                font-size: 16px;
              });
              &::after{
                content: '';
                width: 12px;
                height: 12px;
                border: 0px;
                border-top: solid 2px #FFF;
                border-right: solid 2px #FFF;
                -ms-transform: rotate(45deg);
                -webkit-transform: rotate(45deg);
                transform: rotate(45deg);
                position: absolute;
                top: 40%;
                right: 15%;
                .screen-xs({
                  width: 6px;
                  height: 6px;
                  border-top: solid 1px #FFF;
                  border-right: solid 1px #FFF;
                  top: 42%;
                });
              }
            }
            a{
              padding: 24px 0;
              width: 100%;
              color: #FFF;
              display: block;
              text-decoration: none;
              .screen-xs({
                padding: 16px 0;
              });
            }
          }
        }
      }
    }

    .four_column{
      margin-bottom: 100px;
      .screen-xs({
        margin-bottom: 50px;
      });
      ul{
        list-style: none;
        li{
          padding-top: 140px;
          width: 22%;
          float: left;
          .screen-xs({
            padding-top: 50px;
            width: 48%;
          });
          &:nth-child(n+2){
            margin-left: 4%;
          }
          &:nth-of-type(3){
            .screen-xs({
              margin-left: 0;
            });
          }
          a{
            text-decoration: none;
            img{
              margin-bottom: 10px;
              width: 100%;
            }
            p{
              color: #000;
              font-size: 18px;
            }
          }
        }
      }
    }
  }
</style>

<script>
  export default {
    name: 'bunkazai'
  }
</script>